<h2>Customer type</h2>

<mat-radio-group [(ngModel)]="customerType">
  <mat-radio-button value="organisationCustomer">Organisation customer</mat-radio-button>
  <mat-radio-button *ngIf="!angieOnly" value="ibex3">Ibex3 customer</mat-radio-button>
</mat-radio-group>

<div class="spacer"></div>

<data-table (custom)="onSelect($event)"
                *ngIf="customerType === 'organisationCustomer'"
                [columns]="columnsOrganisationCustomer"
                [dataProvider]="organisationCustomerService"
                [title]="'Organisation Customers'"
                [validator]="{ validate:'_id',  target: this.data.ids }"
                alternative_icon=null
                icon="add_circle"
></data-table>

<data-table (custom)="onSelect($event)"
                *ngIf="customerType === 'ibex3'"
                [columns]="columnsIbex3"
                [dataProvider]="customerService"
                [title]="'Ibex 3 Customers'"
                [validator]="{ validate:'_id',  target: this.data.ids }"
                alternative_icon=null
                icon="add_circle"
></data-table>

<div class="spacer"></div>

<div class="button-right-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>cancel</button>
</div>
